import React from 'react';
import {
  CircleRadioWrapper,
  CircleRadioLabel,
  CircleRadioInput,
  CircleRadioSpan,
} from './styles';

const CircleRadioButton = ({ diameter, border, color, selected, ...rest }) => (
  <CircleRadioWrapper {...rest}>
    <CircleRadioLabel {...rest}>
      <CircleRadioInput {...rest} type="radio" />
      <CircleRadioSpan
        {...rest}
        $diameter={diameter}
        $border={border}
        $color={color}
        $selected={selected}
      />
    </CircleRadioLabel>
  </CircleRadioWrapper>
);

export default CircleRadioButton;